import { Maximize2, ShieldCheck, X } from "lucide-react";
import { Link } from "react-router-dom";

const STATUS_LABELS = {
  connecting: "Connecting",
  connected: "Connected",
  unavailable: "Unavailable",
};

export const EmbeddedChatHeader = ({ status, onClose, closeButtonRef }) => (
  <header className="embedded-chat-header" data-testid="floating-chat-header">
    <div className="embedded-chat-header__brand">
      <span className="embedded-chat-header__mark" aria-hidden="true"><ShieldCheck /></span>
      <div>
        <strong data-testid="floating-chat-title">SuppleAI</strong>
        <span className={`embedded-chat-header__status is-${status}`} data-testid="floating-chat-status">
          <i aria-hidden="true" />{STATUS_LABELS[status]}
        </span>
      </div>
    </div>
    <div className="embedded-chat-header__actions">
      <Link to="/chat" aria-label="Open full-page chat" title="Open full-page chat" data-testid="floating-chat-full-page-link"><Maximize2 aria-hidden="true" /></Link>
      <button ref={closeButtonRef} type="button" onClick={onClose} aria-label="Close SuppleAI" title="Close SuppleAI" data-testid="floating-chat-close-btn"><X aria-hidden="true" /></button>
    </div>
  </header>
);